import styled from 'styled-components'
import { theme } from '~/styles'

interface RadioWrapper {
  error?: boolean
}

export const RadioContainer = styled.div`
  display: flex;
`

export const RadioWrapper = styled.div<RadioWrapper>`
  display: flex;
  margin-right: ${({ theme }) => theme.zds.spacing.inline500};

  input[type='radio'] {
    vertical-align: middle;
    width: 20px;
    height: 20px;
    border-radius: 10px;
    border: 0;
    transition: box-shadow 150ms;
    box-shadow: inset 0 0 0 1px ${theme.colors.color6b7786};
    appearance: none;
    padding: 0;
    margin: 0;
    cursor: pointer;

    &:focus {
      outline: none;
      box-shadow: inset 0 0 0 1px ${theme.colors.color378ff7};
    }
    &:checked {
      box-shadow: inset 0 0 0 4px ${({ theme }) => theme.zds.colors.neutral1000};
      background: ${theme.colors.color378ff7};
      border: 1px solid ${theme.colors.color378ff7};
    }
    &:checked + label {
      color: ${theme.colors.color378ff7};
    }
    &:focus + label {
      color: ${theme.colors.color378ff7};
    }
  }

  &:hover > input {
    box-shadow: inset 0 0 0 1px ${theme.colors.color378ff7};
  }
`

export const RadioElement = styled.input`
  margin: 0;
  width: 20px;
  height: 20px;
`

export const RadioLabel = styled.label<RadioWrapper>`
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 400;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-left: ${({ theme }) => theme.zds.spacing.insetEqual300};
  color: ${({ error }) => (error ? theme.colors.colorFF2424 : theme.colors.color6b7786)};
`
